import React from "react";
import FilterBox from "../../../Utils/FilterBox/FilterBox"
import { useTranslation } from "react-i18next";

function Filter(props) {
    const { t } = useTranslation()

    const { setPageParams } = props

    let filterTypes = {
        external_id: {
            type: "string",
            disabled: false,
            validation: false,
            description: t("Nome da Ocorrência")
        },
        status: {
            type: "enum",
            enumList: [[t('in_batch'), 'in_batch'], [t('out_of_batch'), 'out_of_batch']],
            disabled: false,
            validation: false,
            description: t("Status")
        },
        regulatory_authority: {
            type: "enum",
            enumList: [[t("BACEN"), "bacen"], [t("CVM"), "cvm"]],
            disabled: false,
            validation: false,
            description: t("regulatory_authority")
        },
        created_at: {
            type: "date",
            disabled: false,
            validation: false,
            description: t("Data de Criação")
        }
    }

    return (
        <FilterBox
            setPageParams={setPageParams}
            filterTypes={filterTypes}
            local_storage_object_preffix={props.local_storage_object_preffix}
        />
    )

}

export default Filter